import React from 'react';
import $i18n from 'panda-i18n';

const NotFind = () => {
  return (
    <>
      <h1>{$i18n.get({ id: 'UnableToFindTheWebpage.four_px', dm: '找不到网页' })}</h1>
      <p>{$i18n.get({ id: 'WeCanTFindWhatYou_2929274482.four_px', dm: '我们找不到您要找的东西。' })}</p>

      <p>
        {$i18n.get({
          id: 'PleaseContactTheOwnerOfThe_253073563.four_px',
          dm: '请联系将您链接到原始 URL 的站点的所有者，并让他们知道链接已损坏。',
        })}
      </p>
    </>
  );
};

export default NotFind;
